import { withServerSideProxy } from './proxy';
const sessionStorageHelpers = {
  getSessionStorageItem: key => sessionStorage.getItem(key),
  removeSessionStorageItem: key => sessionStorage.removeItem(key),
  setSessionStorageItem: (key, value) => sessionStorage.setItem(key, value)
};
const serverSafeSessionStorageHelpers = withServerSideProxy(sessionStorageHelpers, {
  getSessionStorageItem: () => null
});
export const {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem
} = serverSafeSessionStorageHelpers;